// Contract with the Talkvia AI runtime: the agent bot stores
// bot_config.webhook_integration_link = { app_id: 'asaas', hook_id: <id>, ... }
// and the backend forwards the enabled hook with its API key filtered.
export const ASAAS_APP_ID = 'asaas';

const isHookEnabled = hook =>
  hook?.status === true || hook?.status === 'enabled';

export const buildAsaasIntegrationOptions = (hooks = [], hint = '') =>
  hooks.filter(isHookEnabled).map(hook => ({
    value: `${ASAAS_APP_ID}:${hook.id}`,
    label: 'Asaas',
    hint,
    config: {
      key: `${ASAAS_APP_ID}:${hook.id}`,
      app_id: ASAAS_APP_ID,
      type: ASAAS_APP_ID,
      mode: 'single',
      hook_id: hook.id,
      integration_name: 'Asaas',
    },
  }));

export const asaasIntegrationLinkKey = link =>
  link?.app_id === ASAAS_APP_ID && link?.hook_id
    ? `${ASAAS_APP_ID}:${link.hook_id}`
    : '';
